import axios from "axios";
import CacheHelper from "../helpers/cache-helper";


export class BaseAPI {
  baseURL = "/api/v1/";
  /**
   * @constructor
   */
  constructor() {
    let app = CacheHelper.get();
    this.api = axios.create({
      baseURL: this.baseURL
    });
  }

  /**
   * Se encarga de recuperar la lista de los recursos
   * @param {*} params criterios de filtrado y paginado.
   */
  listar(params) {
    return axios.create({ baseURL: this.baseURL }).get(this.resource, {
      params: params
    });
  }

  /**
   * Se encarga de recuperar los del recurso por su id
   * @param {number}id
   */
  obtener(id) {
    return this.api.get(this.resource + id);
  }

  /**
   * Se encarga de actualizar los datos del recurso
   * @param {*} data
   */
  actualizar(data) {
    return this.api.put(this.resource + data.id, data);
  }

  /**
   * Se encarga de agregar un nuevo recurso
   * @param {*} data
   */
  agregar(data) {
    return this.api.post(this.resource, data);
  }

  /**
   * Se encarga de eliminar el recurso por su id
   * @param {number} id
   */
  eliminar(id) {
    return this.api.delete(this.resource + id);
  }
}
